// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__14tIU","label":"PriceFilterPopup_label__2MaVm","labelSelected":"PriceFilterPopup_labelSelected__2V_LF"};